﻿[<AutoOpen>]
module Illy.SafeStack.Client.Types
open Elmish

[<RequireQualifiedAccess>]
type SideEffect<'a, 'b> = 
    | Cmd of Cmd<'a>
    | Event of 'b

module SideEffect =
    let none = SideEffect.Cmd []
    let map f =
        function
        | SideEffect.Cmd c -> Cmd.map f c |> SideEffect.Cmd
        | SideEffect.Event e -> SideEffect.Event e

type ControlSettings = 
    {
        CSSClasses: string list
    }

module ControlSettings = 
    let defaultOptions = 
        {
            CSSClasses = []
        }

[<StructuralEquality>]
[<StructuralComparison>]
type ControlState<'control,'customSettings>=
    {
        Control: 'control
        Settings: ControlSettings
        CustomSettings: 'customSettings
    }